module.exports = __webpack_public_path__ + "69512b1fe794e2b1398c0f0eb3027b2a.svg";